// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { CustomEvent } from '@shared/utils/CustomEvents';
import TerceraBoolNumericTemplate from '@front/templates/TerceraBoolNumericTemplate.html';
import { ContainerControl } from './ContainerControl';
export class TerceraBoolNumeric extends ContainerControl {
    constructor() {
        super();
        this.onBoolDataChanged = (event) => {
            void this.set('boolNumericData.Checked', event.currentTarget.checked);
        };
    }
    oninit() {
        super.oninit();
        this.BoolNumericDataChanged = new CustomEvent();
        this.observe('boolNumericData', this.onBoolNumericDataChanged);
    }
    onBoolNumericDataChanged(newVal) {
        this.BoolNumericDataChanged.Raise(this, newVal);
    }
}
ContainerControl.extendWith(TerceraBoolNumeric, {
    data: function () {
        return {
            labelText: '',
            boolNumericData: null,
            minValue: 1,
            maxValue: 100000,
            step: 1,
            decimalPrecision: 0
        };
    },
    template: TerceraBoolNumericTemplate
});
